/**
 * Get REST URL
 *
 * @returns {string}
 */
const getRestUrl = () => {
  const shouldUseLocalRest = document.cookie
    .split(';')
    .find(elem => (
      elem.split('=')[0].trim() === 'localRest'
      && elem.split('=')[1] === '1'
    ));

  return shouldUseLocalRest
      ? 'http://localhost:3000'
      : 'https://manutd.one';
}

/**
 * Get players statistic
 *
 * @returns {Promise}
 */
export const fetchData = () => {
  const restUrl = getRestUrl();

  return fetch(`${restUrl}/restApi/getXStats`)
    .then(response => response.json());
}

export const toggleBodyClass = () => {
  const body = document.querySelector('body');

  if (!body) {
    return;
  }

  body.classList.toggle('xStatTableExpanded');
}

/**
 * Format number to approprivate format
 * 
 * @param {string} number String float value
 * @returns {number}
 */
export const toFloat = number => parseFloat(number).toFixed(2);

/**
 * Function to sort table columns
 * 
 * @returns {number}
 */
export const valuesSorter = (a, b) => {
  // Null and undefined to the bottom
  a = (a === null || a === undefined) ? -Infinity : a;
  b = (b === null || b === undefined) ? -Infinity : b;

  // Any string values to lowercase
  a = parseFloat(a).toString().length === a.toString().length
    ? parseFloat(a)
    : a.toLowerCase();

  b = parseFloat(b).toString().length === b.toString().length
    ? parseFloat(b)
    : b.toLowerCase();

  // Return either 1 or -1 to indicate a sort priority
  if (a > b) {
    return 1;
  }
  if (a < b) {
    return -1;
  }

  return 0;
};
